import { render, staticRenderFns } from "./add-to-homescreen.vue?vue&type=template&id=323fe56e&scoped=true"
import script from "./add-to-homescreen.vue?vue&type=script&lang=js"
export * from "./add-to-homescreen.vue?vue&type=script&lang=js"
import style0 from "./add-to-homescreen.vue?vue&type=style&index=0&id=323fe56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323fe56e",
  null
  
)

export default component.exports